import CloseIcon from '@mui/icons-material/Close';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import { Box, Button, Dialog, IconButton, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React from "react";

export default function MstExclusiveModal({ open, handleClose, isLoggedIn, onSignUp }) {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{
                sx: {
                    width: "100%",
                    maxWidth: 600,
                    m: 2,
                    borderRadius: 2,
                    overflow: "hidden",
                    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
                },
            }}
        >
            <Stack direction="row" sx={{ position: "relative" }}>
                <Box
                    sx={{
                        width: { xs: 88, sm: 128 },
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                    }}
                >
                    <WorkspacePremiumOutlinedIcon sx={{ fontSize: { xs: 40, sm: 52 }, color: "primary.main" }} />
                </Box>

                <Box sx={{ flex: 1, py: 3, pl: 2.5, pr: 5 }}>
                    <IconButton
                        onClick={handleClose}
                        size="small"
                        sx={{ position: "absolute", top: 6, right: 6, color: "text.disabled" }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                    <Typography variant="h4" sx={{ color: "red", fontWeight: 700, letterSpacing: 0.5 }}>
                        Exclusive for MST customers
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 600, mt: 0.5 }}>
                        Start investing in RX Ayodhya 2 at INR 10,000.
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75, mb: 2 }}>
                        Complete your Registration and KYC to avail this offer. This deal is exclusive for MST customers, Signup to know more.
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={isLoggedIn ? handleClose : onSignUp}
                        sx={{ borderRadius: 1.5, px: 3 }}
                    >
                        {isLoggedIn ? "View Deal" : "Sign Up"}
                    </Button>
                </Box>
            </Stack>
        </Dialog>
    );
}
